import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { errorRed, tintRed } from "../../design-system/colors";
import MoovsBanner from "../globals/MoovsBanner";

function ExpiredTripBanner() {
  return (
    <MoovsBanner
      bannerText="This trip has expired. Customer and driver data are no longer available."
      bannerBgColor={tintRed}
      bannerTextColor={errorRed}
      bannerIcon={<ErrorOutlineIcon style={{ color: errorRed }} />}
    />
  );
}

export default ExpiredTripBanner;